import { IS_PRODUCTION } from 'shared/config/env';
import { cratChain, wagmiConfig } from 'shared/config/wagmi';
import { getContract } from 'viem';

import { TAP2MINE_ABI } from '../abi';

const address = {
  testnet: '0x064B719cCE817D4B4EE27EA5Cd8A7cA9B3dd53cC',
  mainnet: '0xf6B144B0c24A66Ced0d45a6C1898965C04909639',
} as const;

export const tap2mineContract = getContract({
  abi: TAP2MINE_ABI,
  address: IS_PRODUCTION ? address.mainnet : address.testnet,
  client: wagmiConfig.getClient({
    chainId: cratChain.id,
  }),
});
